<template>
  <div class="animated fadeIn">
    <div class="max-width-1 mx-auto mt4">
      <div class="clearfix">
        <div class="col-12 flex justify-end items-end mb4 right-align">
          <a href="#/login" class="h6 gibson inline-block primarycolor right-align">Tilbage</a>
        </div>
        <div class="col-12 px2 mb2">
          <div class="flex justify-start items-center">
            <img src="/static/svg/h.svg" class="inline-block" alt="" height="36" />
            <p class="h5 darkblue semi-bold gibson line-height-1 pl2 mb0">Håndværker.dk</p>
          </div>
          <div>
            <p class="h2 mt3 mb1 gibson line-height-golden semi-bold darkblue">Glemte dit password?</p>
          </div>
          <div>
            <p class="h5 mt3 mb1 gibson line-height-golden semi-bold darkblue">Indtast din email og klik på "Send" og vil vil emaile din adgangskode.</p>
          </div>
        </div>
        <div class="col-12">
          <div class="lightgrey-background" style="padding:0.3rem;">
            <form @submit="onSubmit">
              <div class="border white-background mediumgrey-border py2 px2">
                <div>
                  <label>Email</label>
                  <input id="email" v-model="form.username" type="email" required class="h6 regular not-rounded border mediumgrey-border p2 darkblue col-12 line-height-1 light-highlights" autocomplete="username">
                </div>
                <div class="border red-border red white-background p2" v-if="form.errorMessage">
                  <div class="h6">{{ form.errorMessage }}</div>
                </div>
              </div>
              <div class="my2 lightgrey-background px2">
                <button type="submit" id="formLogin" class="h5 block col-12 action-button p2 gibson border-none not-rounded">
                  <span>Send logindata</span>
                </button>
              </div>
              <div>
                <loading :show="show" :label="label" :overlay="overlay" class="loading-wrap"></loading>
              </div>
            </form>
          </div>   
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import loading from 'vue-full-loading'
export default {
  name: 'ProjectPassword',
  components: {
    loading
  },
  data: function () {
    return {
      form: {
        username: '',
        password: '',
        errorMessage: ''
      },
      user: {
        name: '',
        token: '',
        role: ''
      },
      show: false,
      label: '',
      overlay: false
    }
  },
  created () {
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.show = true
      // alert(JSON.stringify(this.form))
      var data = { operation: 'forgot', userName: this.form.username }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res === '1') {
              this.form.errorMessage = 'logindata vil sende til din email-adresse!'
              this.form.username = ''
            } else if (res === '1') {
              this.form.errorMessage = 'Partner ikke fundet'
            } else if (res === '2') {
              this.form.username = ''
              this.form.errorMessage = 'E-mail ikke sendt !'
            }
          },
          response => {
            alert('error')
          }
        )
    },
    forgotPassword (evt) {
      this.$router.push('/glemte-password')
    }
  }
}
</script>


// WEBPACK FOOTER //
// ForgotPassword.vue?142d7787